// src/hooks/useTheme.ts
import { useState, useEffect, createContext, useContext } from 'react';
import { ThemeName, createLoxiaTheme } from '../config/themes';
import { brand } from '../config/brand';

interface ThemeContextType {
  currentTheme: ThemeName;
  changeTheme: (theme: ThemeName) => void;
  theme: any;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeContext = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return context;
};

export const useThemeStorage = () => {
  const [currentTheme, setCurrentTheme] = useState<ThemeName>(() => {
    const stored = localStorage.getItem(`${brand.storagePrefix}-theme`);
    return (stored as ThemeName) || 'light';
  });

  const changeTheme = (theme: ThemeName) => {
    setCurrentTheme(theme);
    localStorage.setItem(`${brand.storagePrefix}-theme`, theme);
  };

  const theme = createLoxiaTheme(currentTheme);

  useEffect(() => {
    // Apply theme to document root for CSS custom properties
    document.documentElement.setAttribute('data-theme', currentTheme);
  }, [currentTheme]);

  return { currentTheme, changeTheme, theme };
};